<template>
  <div>
    <v-overlay v-if="active">
      <v-snackbar v-model="snackbar" :timeout="timeout"> 
        <v-btn
      x-small
      fab
      dark 
      color="red"
      class="mr-2"
       @click.native="hideSnackbar(false)"
    >
      <v-icon dark>
        mdi-close
      </v-icon>
    </v-btn>  {{ text }} 
      </v-snackbar></v-overlay
    >
  </div>
</template>
<script>
export default {
  props: ["active", "text"],
  data: () => ({
    snackbar: false,
    timeout: -1, 
  }),

  watch: {
    active: function (newVal, oldVal) { 
      this.snackbar = newVal;
    },
  }, 
  methods: {
    hideSnackbar(val) {
      this.$emit("hideSnackbar", val);
      this.snackbar = val;
    },
  },
};
</script>